import { useState, useCallback, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { nestApi } from "@/lib/api";

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [inactive, setInactive] = useState(false);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);

  useEffect(() => {
    nestApi
      .get("/rahe-portal/me")
      .then(({ data }) => {
        const type = data?.raheStatus?.type;
        setInactive(type === "INACTIVE");
      })
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="dashboard-layout">
      <Sidebar open={sidebarOpen} onClose={closeSidebar} />
      <Header 
        onMenuClick={() => setSidebarOpen(true)} 
        inactive={inactive}
        setInactive={setInactive}
      />
      <main className="lg:ml-64 pt-20 px-4 sm:px-6 lg:px-8 pb-8">
        <Outlet context={{ inactive, setInactive }} />
      </main>
    </div>
  );
}
